<template>
  <div class="metric-charter-authorizer description" v-if="isSelectedSchoolCharter">
    <template v-if="isSelectedSchoolPK">Charter Pre-K schools do not receive Quality Reviews.</template>
    <template v-else>Charter schools do not receive Quality Reviews from New York City. Instead, they are monitored and evaluated by authorizers. This school's authorizer is <b>{{authorizerName}}</b>. <LinkExternalUrl :url="websiteValue">Charter school reports produced by the authorizer are available at its website.</LinkExternalUrl></template>
  </div>
</template>

<script>
import Component, { mixins } from 'vue-class-component'
import { mapGetters } from 'vuex'

import { MetadataWebsiteMixin } from './metadata-mixin'
import { NS_CURRENT_REPORT } from '../const'

import LinkExternalUrl from '@/components/LinkExternalUrl'

/* Valid Slot Names for this Component */
const SN_NAME = 'name_value'

@Component({
  computed: {
    ...mapGetters(NS_CURRENT_REPORT, [
      'isSelectedSchoolCharter',
      'isSelectedSchoolPK'
    ])
  },
  components: {
    LinkExternalUrl
  }
})
export default class MetricCharterAuthorizer extends mixins(MetadataWebsiteMixin) {
  /* Getters */
  get authorizerName () { return this.dispValueForSlotName(SN_NAME) }
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/sqs/2025/tab-mods/MetricCharterAuthorizer.vue